export default "__VITE_ASSET__2ee3d4c1__"